export default __webpack_public_path__ + "static/media/finews.20f6a9b8.svg";